export const ProgressStateConstant = {
    MAINPAGE : "",
    WORKFLOW : "workflow",
}